import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from '../src/router/index';
import reportWebVitals from './reportWebVitals';
import "../src/libcss";
import interceptors from './Utils/Interceptors'
import { Provider } from 'react-redux'
import store from './redux/store'
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserProperties, setUserId } from "firebase/analytics";


const firebaseConfig = {
    apiKey: "AIzaSyA25xfj5evqeWVg-bdt5Ny28QMQfnOQbUU",
    authDomain: "thehandbook-f4f2f.firebaseapp.com",
    databaseURL: "https://thehandbook-f4f2f.firebaseio.com",
    projectId: "thehandbook-f4f2f",
    storageBucket: "thehandbook-f4f2f.appspot.com",
    messagingSenderId: "249539256975",
    appId: "1:249539256975:web:17bc011c52167adb3086fa",
    measurementId: "G-D7RZK7JG62"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);



logEvent(analytics, "Handbook Web app Loaded", { name: '' });
// console.log('test event logged from firebase config');

export const log_firebase_event = (event, params) => {
    logEvent(analytics, event, params);
}

export const setFirebaseUserProperties = (params) => {

    setUserProperties(analytics, params)
}

export const setFirebaseUserId = (userid) => {
    setUserId(analytics, userid)
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    /*<React.StrictMode>
      <App />
    </React.StrictMode>*/
    <>
        <Provider store={store}>
            <App />
        </Provider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
interceptors();
